// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dev-panel[data-v-76ffc04c]{position:fixed;left:0;bottom:0;width:400px;height:auto;padding:20px;color:#fff;background-color:rgba(0,0,0,.5);z-index:9999999;word-break:break-all}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
